<template>
  <div>

    <a-modal
        :title='title'
        :visible="visible"
        v-bind="drawerConfig"
        :body-style="{ paddingBottom: '80px' }"
        @cancel="onClose"
    >

      <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout"   layout="vertical">
          <a-form-model-item
              ref="analysis_keyword_prompt"
              label="分析关键词指令："
              prop="analysis_keyword_prompt"
              :help="formErr.analysis_keyword_prompt"
              :validateStatus='!formErr.analysis_keyword_prompt||formErr.analysis_keyword_prompt==""?"":"error"'
          >
            <a-input type="textarea" style="height: 120px"
                     :maxLength=5000
                     v-model="form.analysis_keyword_prompt"
                     @change="(e) => { formErr.analysis_keyword_prompt=''}"
                     @blur="(e) => {  form.analysis_keyword_prompt = e.target.value.trim();}"
            />
          </a-form-model-item>
          <a-form-model-item
              ref="page_analysis_user_prompt"
              label="页面理解层："
              prop="page_analysis_user_prompt"
              :help="formErr.page_analysis_user_prompt"
              :validateStatus='!formErr.page_analysis_user_prompt||formErr.page_analysis_user_prompt==""?"":"error"'
          >
            <a-input type="textarea" style="height: 120px"
                 :maxLength=5000
                 v-model="form.page_analysis_user_prompt"
                 @change="(e) => { formErr.page_analysis_user_prompt=''}"
                 @blur="(e) => {  form.page_analysis_user_prompt = e.target.value.trim();}"
            />
          </a-form-model-item>
          <a-form-model-item
              ref="serp_strategy_user_prompt"
              label="SERP策略层："
              prop="serp_strategy_user_prompt"
              :help="formErr.serp_strategy_user_prompt"
              :validateStatus='!formErr.serp_strategy_user_prompt||formErr.serp_strategy_user_prompt==""?"":"error"'
          >
            <a-input type="textarea" style="height: 120px"
                 :maxLength=5000
                 v-model="form.serp_strategy_user_prompt"
                 @change="(e) => { formErr.serp_strategy_user_prompt=''}"
                 @blur="(e) => {  form.serp_strategy_user_prompt = e.target.value.trim();}"
            />
          </a-form-model-item>
        <a-form-model-item
            ref="rewrite_blueprint_user_prompt"
            label=" 改写规划层："
            prop="rewrite_blueprint_user_prompt"
            :help="formErr.rewrite_blueprint_user_prompt"
            :validateStatus='!formErr.rewrite_blueprint_user_prompt||formErr.rewrite_blueprint_user_prompt==""?"":"error"'
        >
          <a-input type="textarea" style="height: 120px"
                   :maxLength=5000
                   v-model="form.rewrite_blueprint_user_prompt"
                   @change="(e) => { formErr.rewrite_blueprint_user_prompt=''}"
                   @blur="(e) => {  form.rewrite_blueprint_user_prompt = e.target.value.trim();}"
          />
        </a-form-model-item>
        <a-form-model-item
            ref="generated_content_user_prompt"
            label="内容生成层："
            prop="generated_content_user_prompt"
            :help="formErr.generated_content_user_prompt"
            :validateStatus='!formErr.generated_content_user_prompt||formErr.generated_content_user_prompt==""?"":"error"'
        >
          <a-input type="textarea" style="height: 120px"
                   :maxLength=5000
                   v-model="form.generated_content_user_prompt"
                   @change="(e) => { formErr.generated_content_user_prompt=''}"
                   @blur="(e) => {  form.generated_content_user_prompt = e.target.value.trim();}"
          />
        </a-form-model-item>
        <a-form-model-item
            ref="quality_validation_user_prompt"
            label="质检回归层："
            prop="quality_validation_user_prompt"
            :help="formErr.quality_validation_user_prompt"
            :validateStatus='!formErr.quality_validation_user_prompt||formErr.quality_validation_user_prompt==""?"":"error"'
        >
          <a-input type="textarea" style="height: 120px"
                   :maxLength=5000
                   v-model="form.quality_validation_user_prompt"
                   @change="(e) => { formErr.quality_validation_user_prompt=''}"
                   @blur="(e) => {  form.quality_validation_user_prompt = e.target.value.trim();}"
          />
        </a-form-model-item>
      </a-form-model>
      <div class="drawer-btn"  style="text-align: center" >
        <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">确定</a-button>
        <a-button @click="onClose">取消</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {submitForm,drawerConfig,validator} from "../../../../../../utils/utils"

import API from "../api";
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}
export default {
  name: "videoForm",
  // props: ["visible","title","editId"],
  props: {
    visible:{type: Boolean,},
    title:{type: String,},
    editId:{type: [String, Number],},

  },
  data() {
    return {
      contenta: "",
      headers: {Authorization: window.sessionStorage.getItem("signature")},
      seleList:[],
      fileList:[],
      previewVisible: false,
      previewImage: "",
      drawerConfig ,
      form: {
        analysis_keyword_prompt:"",
        page_analysis_user_prompt:"",
        serp_strategy_user_prompt :"",
        rewrite_blueprint_user_prompt:"",
        generated_content_user_prompt:"",
        quality_validation_user_prompt:"",
        type:"1",
      },
      formErr: {
        analysis_keyword_prompt:"",
        page_analysis_user_prompt:"",
        serp_strategy_user_prompt :"",
        rewrite_blueprint_user_prompt:"",
        generated_content_user_prompt:"",
        quality_validation_user_prompt:"",
      },
      rules: {
          page_analysis_user_prompt: [{required: true, message: "请输入页面理解层",  },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.page_analysis_user_prompt)}  , trigger: "blur"  },],
          analysis_keyword_prompt: [{required: true, message: "请输入分析关键词指令",  },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.analysis_keyword_prompt)}  , trigger: "blur"  },],
          serp_strategy_user_prompt: [{required: true, message: "请输入SERP策略层",  },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.serp_strategy_user_prompt)}  , trigger: "blur"  },],
        rewrite_blueprint_user_prompt: [{required: true, message: "请输入改写规划层",  },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.rewrite_blueprint_user_prompt)}  , trigger: "blur"  },],
        generated_content_user_prompt: [{required: true, message: "请输入内容生成层",  },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.generated_content_user_prompt)}  , trigger: "blur"  },],
        quality_validation_user_prompt: [{required: true, message: "请输入质检回归层",  },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.quality_validation_user_prompt)}  , trigger: "blur"  },],

      },
      layout: {
        // labelCol: { span:3},
        // wrapperCol: { span: 20 },

      },
    };

  },
  watch:{
    editId: function (a, b) {
      if (a != "") {
        API.service.EDIT_DATAS(a).then(res => {
          let data=res.data.data.info
          this.form = data
          this.form.id=a
          this.form.type='1'
        })
      } else {
        this.form.id = ''
        this.form.type='1'
      }
    }
  },
  mounted(){
  },
  methods: {

    handleCancel() {
      this.previewVisible = false;
    },

    onClose() {
      this.$emit("changVisible", false);
      this.fileList=[]
      this.form={
        analysis_keyword_prompt:"",
        page_analysis_user_prompt:"",
        serp_strategy_user_prompt :"",
        rewrite_blueprint_user_prompt:"",
        generated_content_user_prompt:"",
        quality_validation_user_prompt:"",
      }
      this.formErr={
        analysis_keyword_prompt:"",
        page_analysis_user_prompt:"",
        serp_strategy_user_prompt :"",
        rewrite_blueprint_user_prompt:"",
        generated_content_user_prompt:"",
        quality_validation_user_prompt:"",
      }
      this.$refs.ruleForm.resetFields();
    },
    onSubmit() {
      let _this = this;

      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let url
          let subData=JSON.parse(JSON.stringify(this.form))

          subData.id == '' || subData.id == undefined ? url = API.service.SUBMIT_ADDS : url = API.service.SUBMIT_EDITS
          if(subData.id == '' || subData.id == undefined){
            submitForm(url, {analysis_keyword_prompt: subData.analysis_keyword_prompt, page_analysis_user_prompt: subData.page_analysis_user_prompt, serp_strategy_user_prompt: subData.serp_strategy_user_prompt,
              rewrite_blueprint_user_prompt: subData.rewrite_blueprint_user_prompt, generated_content_user_prompt: subData.generated_content_user_prompt, quality_validation_user_prompt: subData.quality_validation_user_prompt, type: 1}).then(res => {
              if (res == true) {
                this.onClose()
              } else {
                res.map((item, index) => {
                  this.formErr[item.field] = item.msg
                })
              }
            })
          }else {
            submitForm(url, subData).then(res => {
              if (res == true) {
                this.onClose()
              } else {
                res.map((item, index) => {
                  this.formErr[item.field] = item.msg
                })
              }
            })
          }
        } else {
          return false;
        }
      });
    },
  },
}
</script>

<style scoped>
.ant-input-number-input{width: 100%!important;}
.ant-input-number{width: 100%!important;}
.box >>> .ant-form-extra{top:calc(100% - 30px) !important;position: absolute}
.box >>> .ant-form-item-control-wrapper{position: relative}
.drawer-btnt{text-align:center;}
</style>
